var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Dialog } from "@sequentech/ui-essentials";
import { ETranslationScope, isString, isTranslationScope, parseTranslationOverrideKey, updateTranslationOverride, } from "@sequentech/ui-core";
import { useMemo, useState } from "react";
import { Button, Datagrid, ListContextProvider, Pagination, SaveButton, SimpleForm, TextField, TextInput, WrapperField, useEditController, useList, useNotify, useUpdate, } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
// import { Sequent_Backend_Election_Event_Extended } from "./EditElectionEventDataForm"
import { ActionsColumn } from "@/components/ActionButons";
import { Box, Drawer, FormControl, InputLabel, MenuItem, Select, Typography, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { ThreeStateDatagridHeader } from "@/components/ThreeStateDatagridHeader";
import { TranslationScopeInput, translationScopeLabel } from "@/components/TranslationScopeInput";
import { timeZoneTextOverrideError } from "@/lib/timeZoneTextOverride";
var TENANT_TRANSLATION_SCOPES = [
    ETranslationScope.GLOBAL,
    ETranslationScope.ADMIN_PORTAL,
];
var SettingsLocalization = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    // const record = useRecordContext<Sequent_Backend_Tenant>()
    var tenantId = useTenantStore()[0];
    var _h = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _h.record, save = _h.save, recordLoading = _h.isLoading;
    var defaultLanguageConf = {
        enabled_language_codes: ["en"],
        default_language_code: "en",
    };
    var _j = useState((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf), languageConf = _j[0], setLanguageConf = _j[1];
    var _k = useUpdate(), update = _k[0], isLoading = _k[1].isLoading;
    var t = useTranslation().t;
    var notify = useNotify();
    var _l = useState((_c = languageConf === null || languageConf === void 0 ? void 0 : languageConf.default_language_code) !== null && _c !== void 0 ? _c : "en"), selectedLanguage = _l[0], setSelectedLanguage = _l[1];
    var _m = useState(false), openEdit = _m[0], setOpenEdit = _m[1];
    var _o = useState(false), openCreate = _o[0], setOpenCreate = _o[1];
    var _p = useState(false), openDeleteModal = _p[0], setOpenDeleteModal = _p[1];
    var _q = useState(null), deleteId = _q[0], setDeleteId = _q[1];
    var _r = useState(null), recordId = _r[0], setRecordId = _r[1];
    var languageOptions = useMemo(function () {
        var _a;
        return ((_a = languageConf === null || languageConf === void 0 ? void 0 : languageConf.enabled_language_codes) !== null && _a !== void 0 ? _a : []);
    }, [languageConf === null || languageConf === void 0 ? void 0 : languageConf.enabled_language_codes]);
    var handleLanguageChange = function (event) {
        var _a, _b;
        var value = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        if (!isString(value) || !value)
            return;
        setSelectedLanguage(value);
    };
    var translationData = useMemo(function () {
        var _a, _b;
        return Object.entries(((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b[selectedLanguage]) || {}).map(function (_a) {
            var storedKey = _a[0], value = _a[1];
            var _b = parseTranslationOverrideKey(storedKey), key = _b.key, scope = _b.scope;
            return {
                id: storedKey,
                key: key,
                scope: translationScopeLabel(t, scope, ETranslationScope.ADMIN_PORTAL),
                value: value,
            };
        });
    }, [record === null || record === void 0 ? void 0 : record.settings, selectedLanguage, t]);
    var translationListContext = useList({ data: translationData, perPage: 25 });
    var editAction = function (id) {
        setOpenEdit(true);
        setRecordId(id);
    };
    var deleteAction = function (id) {
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var handleCloseEditDrawer = function () {
        setRecordId(null);
        setOpenEdit(false);
    };
    var handleCreateText = function (e) {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        if (!e)
            return;
        var newKey = (_b = e === null || e === void 0 ? void 0 : e.newKey) !== null && _b !== void 0 ? _b : "";
        var newValue = (_c = e === null || e === void 0 ? void 0 : e.newVal) !== null && _c !== void 0 ? _c : "";
        var newScope = e === null || e === void 0 ? void 0 : e.newScope;
        if (!newValue ||
            !parseTranslationOverrideKey(newKey).key.trim() ||
            !isTranslationScope(newScope))
            return;
        var newTimeZoneError = timeZoneTextOverrideError(t, newKey, newValue);
        if (newTimeZoneError) {
            notify(newTimeZoneError, { type: "error" });
            return;
        }
        var currentTranslations = (_f = (_e = (_d = record === null || record === void 0 ? void 0 : record.settings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e[selectedLanguage]) !== null && _f !== void 0 ? _f : {};
        var updatedTranslations = updateTranslationOverride(currentTranslations, newKey, newScope, newValue);
        if (!updatedTranslations) {
            notify(t("electionEventScreen.localization.notify.duplicateKey", {
                defaultValue: "An override with this key and portal scope already exists.",
            }), { type: "error" });
            return;
        }
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, ((_g = record === null || record === void 0 ? void 0 : record.settings) !== null && _g !== void 0 ? _g : {})), { i18n: __assign(__assign({}, ((_j = (_h = record === null || record === void 0 ? void 0 : record.settings) === null || _h === void 0 ? void 0 : _h.i18n) !== null && _j !== void 0 ? _j : {})), (_a = {}, _a[selectedLanguage] = updatedTranslations, _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                setOpenCreate(false);
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                setOpenCreate(false);
            },
        });
    };
    var handleEditText = function (e) {
        var _a;
        var _b, _c, _d, _e, _f;
        if (!e || !recordId)
            return;
        var editVal = (_b = e === null || e === void 0 ? void 0 : e.editableVal) !== null && _b !== void 0 ? _b : "";
        var editKey = parseTranslationOverrideKey(String(recordId)).key;
        var editScope = e === null || e === void 0 ? void 0 : e.editableScope;
        if (!editVal || !editKey.trim() || !isTranslationScope(editScope))
            return;
        var editTimeZoneError = timeZoneTextOverrideError(t, editKey, editVal);
        if (editTimeZoneError) {
            notify(editTimeZoneError, { type: "error" });
            return;
        }
        var currentTranslations = (_e = (_d = (_c = record === null || record === void 0 ? void 0 : record.settings) === null || _c === void 0 ? void 0 : _c.i18n) === null || _d === void 0 ? void 0 : _d[selectedLanguage]) !== null && _e !== void 0 ? _e : {};
        var updatedI18nForLanguage = updateTranslationOverride(currentTranslations, editKey, editScope, editVal, String(recordId));
        if (!updatedI18nForLanguage) {
            notify(t("electionEventScreen.localization.notify.duplicateKey", {
                defaultValue: "An override with this key and portal scope already exists.",
            }), { type: "error" });
            return;
        }
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, record === null || record === void 0 ? void 0 : record.settings), { i18n: __assign(__assign({}, (_f = record === null || record === void 0 ? void 0 : record.settings) === null || _f === void 0 ? void 0 : _f.i18n), (_a = {}, _a[selectedLanguage] = updatedI18nForLanguage, _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                handleCloseEditDrawer();
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                handleCloseEditDrawer();
            },
        });
    };
    var confirmDeleteAction = function () {
        var _a;
        var _b, _c, _d;
        if (!deleteId || !selectedLanguage)
            return;
        var updatedI18nForLanguage = __assign({}, (_c = (_b = record === null || record === void 0 ? void 0 : record.settings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c[selectedLanguage]);
        delete updatedI18nForLanguage[deleteId];
        update("sequent_backend_tenant", {
            id: record === null || record === void 0 ? void 0 : record.id,
            data: __assign(__assign({}, record), { settings: __assign(__assign({}, record === null || record === void 0 ? void 0 : record.settings), { i18n: __assign(__assign({}, (_d = record === null || record === void 0 ? void 0 : record.settings) === null || _d === void 0 ? void 0 : _d.i18n), (_a = {}, _a[selectedLanguage] = updatedI18nForLanguage, _a)) }) }),
            previousData: record,
        }, {
            onError: function () {
                notify(t("electionEventScreen.localization.notify.error"), { type: "error" });
                handleCloseEditDrawer();
            },
            onSuccess: function () {
                notify(t("electionEventScreen.localization.notify.success"), { type: "success" });
                handleCloseEditDrawer();
            },
        });
    };
    var actions = [
        { icon: _jsx(EditIcon, {}), action: editAction },
        { icon: _jsx(DeleteIcon, {}), action: deleteAction },
    ];
    if (!languageOptions || !selectedLanguage) {
        return (_jsx(_Fragment, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("electionEventScreen.localization.emptyHeader") }) }));
    }
    var parsedRecordId = parseTranslationOverrideKey(String(recordId !== null && recordId !== void 0 ? recordId : ""));
    var editRecord = {
        editableKey: parsedRecordId.key,
        editableScope: (_d = parsedRecordId.scope) !== null && _d !== void 0 ? _d : ETranslationScope.ADMIN_PORTAL,
        editableVal: recordId
            ? (_g = (_f = (_e = record === null || record === void 0 ? void 0 : record.settings) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f[selectedLanguage]) === null || _g === void 0 ? void 0 : _g[recordId]
            : undefined,
    };
    return (_jsxs(_Fragment, { children: [_jsxs(SimpleForm, { toolbar: false, children: [_jsxs(Box, { sx: {
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "space-between",
                        }, children: [_jsxs(FormControl, { sx: { width: "50%" }, children: [_jsx(InputLabel, { id: "select-language", children: t("electionEventScreen.localization.selectLanguage") }), _jsx(Select, { labelId: "select-language", fullWidth: true, label: String(t("electionEventScreen.localization.selectLanguage")), onChange: handleLanguageChange, value: selectedLanguage, children: languageOptions &&
                                            languageOptions.map(function (lang) {
                                                return (_jsx(MenuItem, { value: lang, children: t("common.language.".concat(lang)) }, lang));
                                            }) })] }, "select-language"), _jsxs("div", { className: "list-actions", children: [_jsx(Button, { onClick: function () { return setOpenCreate(true); }, label: String(t("common.label.add")), children: _jsx(Add, {}) }), _jsx(Drawer, { anchor: "right", open: openCreate, onClose: function () {
                                            setOpenCreate(false);
                                        }, PaperProps: {
                                            sx: { width: "30%" },
                                        }, children: _jsx(SimpleForm, { record: {}, onSubmit: handleCreateText, toolbar: _jsx(SaveButton, { sx: { marginInline: "1rem" } }), children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("electionEventScreen.localization.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("electionEventScreen.localization.common.subTitle") }), _jsxs(Box, { sx: { display: "flex", gap: 2, width: "100%" }, children: [_jsx(TranslationScopeInput, { source: "newScope", defaultValue: ETranslationScope.ADMIN_PORTAL, allowedScopes: TENANT_TRANSLATION_SCOPES }), _jsx(TextInput, { source: "newKey", label: String(t("electionEventScreen.localization.labels.key")), fullWidth: true })] }), _jsx(TextInput, { source: "newVal", label: String(t("electionEventScreen.localization.labels.value")), multiline: true })] }) }) })] })] }), _jsx(Box, { sx: { flexGrow: 1, width: "100%" }, children: _jsxs(ListContextProvider, { value: translationListContext, children: [_jsxs(Datagrid, { header: ThreeStateDatagridHeader, bulkActionButtons: false, children: [_jsx(TextField, { source: "key", label: String(t("electionEventScreen.localization.labels.key")) }), _jsx(TextField, { source: "scope", label: String(t("electionEventScreen.localization.labels.scope", {
                                                defaultValue: "Portal scope",
                                            })) }), _jsx(TextField, { source: "value", label: String(t("electionEventScreen.localization.labels.value")) }), _jsx(WrapperField, { label: "Actions", children: _jsx(ActionsColumn, { actions: actions }) })] }), _jsx(Pagination, {})] }) })] }), _jsx(Drawer, { anchor: "right", open: openEdit, onClose: handleCloseEditDrawer, PaperProps: {
                    sx: { width: "40%" },
                }, children: _jsx(SimpleForm, { record: editRecord, toolbar: _jsx(SaveButton, { sx: { marginInline: "1rem" } }), onSubmit: handleEditText, children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("electionEventScreen.localization.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("electionEventScreen.localization.common.subTitle") }), _jsxs(Box, { sx: { display: "flex", gap: 2, width: "100%" }, children: [_jsx(TranslationScopeInput, { source: "editableScope", defaultValue: ETranslationScope.ADMIN_PORTAL, allowedScopes: TENANT_TRANSLATION_SCOPES }), _jsx(TextInput, { source: "editableKey", label: String(t("electionEventScreen.localization.labels.key")), readOnly: true, fullWidth: true })] }), _jsx(TextInput, { source: "editableVal", label: String(t("electionEventScreen.localization.labels.value")), multiline: true })] }) }, "".concat(selectedLanguage, ":").concat(String(recordId))) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                        // console.log('handle close')
                    }
                    setOpenDeleteModal(false);
                    setDeleteId(null);
                }, children: t("common.message.delete") })] }));
};
export default SettingsLocalization;
